
export class ChartPackage {

    public id: number = 0;
    public id_other: number = 0;
    public width: number = 750;
    public height: number = 550;
    public maxWidth: string = "100%";
    public maxHeight: string = "100%";
    public title:string = "IFA Chart";

    constructor() {}
    
    dtoToClassMap (dto) {

        var approvedPackageFound = false;
        //loop through all of the packages. Find one that is fully approved, otherwise abort
        for(var i=0;i<dto.cmS_HTML5_Chart_Packages.length;i++){
            if(
                dto.cmS_HTML5_Chart_Packages[i].p &&
                dto.cmS_HTML5_Chart_Packages[i].w &&
                dto.cmS_HTML5_Chart_Packages[i].m &&
                dto.cmS_HTML5_Chart_Packages[i].r &&
                dto.cmS_HTML5_Chart_Packages[i].c &&
                dto.cmS_HTML5_Chart_Packages[i].visible &&
                (dto.cmS_HTML5_Chart_Packages[i].url.indexOf(".zip")>-1 || dto.cmS_HTML5_Chart_Packages[i].url.indexOf(".html")>-1)
            ){
               // console.log("fully approved package found", dto.cmS_HTML5_Chart_Packages[i])
                approvedPackageFound = true;
                this.id = dto.cmS_HTML5_Chart_Packages[i].id;
                this.id_other = dto.cmS_HTML5_Chart_Packages[i].id_other;
                var notes  = JSON.parse(dto.cmS_HTML5_Chart_Packages[i].notes);
                if (notes.width != null) { this.width = notes.width; }
                if (notes.height != null) { this.height = notes.height; }
                if (notes.maxWidth != null) { this.maxWidth = notes.maxWidth; }
                if (notes.maxHeight != null) { this.maxHeight = notes.maxHeight; }
                if (notes.title != null) { this.title = notes.title; } else{
                    this.title= dto.title;
                }
            }
        }

        if(!approvedPackageFound){
// $&("Warning: A chart was embedded, but doesnt contain a fully approved package.",dto)
        }

      
    }  
  
  }
  